/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable  @typescript-eslint/no-duplicate-enum-values */
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import type { NestleFormData, NestleFormErrors } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.types';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const nestleFormDataDefault: NestleFormData = {
    cardColor: CardColor.blue,
    photo: false,
    nickname: '',
    nickname2: '',
    animal: '',
    animalOther: '',
    breed: '',
    date: undefined,
    dateUnknown: null,
    item1: false,
    item2: false,
    item3: false,
    item4: false,
    name: '',
    email: USER_EMAIL || '',
    postInGroup: false,
    promo: false,
    nestleData: false,
    newsletters: false,
    vkData: false,
};

export const nestleFormErrorsDefault: NestleFormErrors = {
    photo: false,
    nickname: false,
    nickname2: false,
    animal: false,
    animalOther: false,
    breed: false,
    date: false,
    name: false,
    email: false,
    promo: false,
    nestleData: false,
    newsletters: false,
    vkData: false,
};

export const nestleFormRequiredStep1: Partial<keyof NestleFormErrors>[] = [
    'photo',
    'nickname',
    'nickname2',
    'animal',
    'animalOther',
    'breed',
    'date',
];
export const nestleFormRequiredStep4: Partial<keyof NestleFormErrors>[] = ['promo', 'nestleData', 'newsletters', 'vkData'];

// @todo: Обновить текста ошибок как появятся.
export enum nestleFormErrorMessages {
    'BAD/REQUEST' = 'Кто-то разбил вазу... Точнее, что-то пошло не так — попробуйте позже',
    // Текст ошибки если юзер загрузил больше карточек чем допустимо
    'MAX/PETS/REACHED' = 'Можно загрузить не более 5 фото питомцев',
    'PET/EXISTS' = 'Вы уже указали эту кличку. Если у вас два Бариска — измените кличку или укажите другую',
    'COMMON' = 'Кто-то разбил вазу... Точнее, что-то пошло не так — попробуйте позже',
}
